import React from "react";
import Votes from "../../../../../model2/voting/votes";
import FieldVoting_View from "../../render/view";
import {FieldViewSize} from "../../../../const";


export default function FieldReaction_InlineValueNotEmpty(props:any) {

    const votes : Votes = Votes.initFromJson(props.value)

    const onToggle = (e:React.SyntheticEvent) => {
        votes.toggleVote()
        props.onChange(votes.toJSON())
    }

    const model = {
        [props.field.fieldId]       : props.value
    }

    return (
        <React.Fragment>
            <div className="ui5-field-dropdown-inline-editable w-100-percent h-100-percent" onClick={onToggle}>
            {/*<div className="ui5-field-editable w-100-percent h-100-percent" onClick={onToggle}>*/}
                <FieldVoting_View field={props.field} model={model} />
            </div>

            {props.children}
        </React.Fragment>
    )
}
